import angular from 'angular';

angular.module('cloudX').directive('contactIcon', [
  function() {
    return {
      restrict: 'E',
      // only open in new tab if website
      template:
        "<a class=\"contact-icon\" ng-attr-target=\"{{(medium === 0 || medium === 3 || medium === 6 || medium === 7 || medium === 8 || medium === 9 || medium === 10 || medium === 11 || medium === 12 || medium === 13 ) ? '_blank' : undefined}}\"  ng-href=\"{{formatHref()}}\" ng-class=\"{'invisible': !data}\"><i class=\"fa fa-fw\" ng-class=\"['fa-map-marker', 'fa-envelope', 'fa-phone', 'fa-link', 'fa-mobile', 'fa-map-marker', 'fa-link', 'fa-link', 'fa-link', 'fa-link', 'fa-link', 'fa-link', 'fa-link', 'fa-link'][medium]\"></i></a>",
      scope: {
        data: '=',
        addrId: '=?',
        medium: '=',
      },
      replace: true,
      controller: [
        '$scope',
        'commOutSvc',
        function($scope, commOutSvc) {
          $scope.formatHref = function() {
            return commOutSvc.formatHref($scope.data, $scope.addrId, $scope.medium);
          };
        },
      ],
    };
  },
]);
